import { EMPTY_FIELD } from 'constants/emptyField';

import { RaRecord } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import {
  DEFAULT_DATE_MASK,
  DEFAULT_TIME_MASK,
  DEFAULT_TIMEZONE,
} from 'shared/mui/DatePicker/config/defaultValues';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { formatInputInTz } from 'utils/date';

export type DateTimeChipFieldProps = {
  label?: string | React.ReactElement;
  source: string;
  timezone?: string;
  dateMask?: string;
  timeMask?: string;
} & Omit<FunctionFieldProps, 'render'>;

export const DateTimeChipField: React.FC<DateTimeChipFieldProps> = ({
  label,
  source,
  timezone = DEFAULT_TIMEZONE,
  dateMask = DEFAULT_DATE_MASK,
  timeMask = DEFAULT_TIME_MASK,
  ...rest
}) => {
  return (
    <FunctionField
      render={(record: RaRecord) => {
        if (!record[source]) {
          return EMPTY_FIELD;
        }
        const date = new Date(record[source]);
        const chipLabel = `${label}: ${formatInputInTz(date, { timezone, format: dateMask })}, ${formatInputInTz(
          date,
          {
            timezone,
            format: timeMask,
          },
        )}`;
        return <Chip label={chipLabel} />;
      }}
      {...rest}
    />
  );
};
